module.exports = __webpack_public_path__ + "static/media/DEFAULT_MEDIUM_AUDIO_4.dcde97b8.mpga";